interface Props {
    isShow: boolean;
}

export default function PolicySchedulePremiumsRates({ isShow }: Props) {
    
    if (!isShow) {
        return null;
    }

    return (
        <div className="">
            <div className="rounded border border-[#c7e0f3] bg-[#eef6fc] px-3 py-3">
                <div className="flex gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#186cb2]" fill="none" viewBox="0 0 24 24" stroke="currentColor" >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M12 22a10 10 0 100-20 10 10 0 000 20z" />
                    </svg>
                    <p className="text-[10px] leading-4 text-[#145a96] sm:text-xs sm:leading-5">
                        Premium rates will be
                        provided by the Actuarial
                        Team and populated
                        automatically.
                    </p>
                </div>
            </div>
        </div>
    )
}
